import { Avatar, Hidden, Menu, MenuItem } from "@material-ui/core";
import { LogoClock, LogoHorizontal } from "@components/logo";
import React, { useRef, useState } from "react";

import { ExitToApp } from "@material-ui/icons";
import { ExternalLinkButton } from "@clockwise/web-commons/src/ui/external-link-button";
import { gcalUrl } from "@clockwise/client-commons/src/constants/site";
import { trim } from "lodash";

type Props = {
  pageTitle: string;
  organization: string | null;
  user: {
    givenName: string | null;
    familyName: string | null;
    externalImageUrl: string | null;
  } | null;
  onLogout: () => void;
  feedbackUrl?: string;
  showCalendarButton?: boolean;
};

export default function TopNav({
  pageTitle,
  user,
  organization,
  onLogout,
  feedbackUrl,
  showCalendarButton = false,
}: Props) {
  const [open, setOpen] = useState(false);
  const anchorEl = useRef<HTMLDivElement>(null);

  const onClick = () => setOpen(true);
  const onClose = () => setOpen(false);
  const onLogoutAndClose = () => {
    onClose();
    onLogout();
  };

  const fullName = trim(`${user?.givenName ?? ""} ${user?.familyName ?? ""}`) || organization || "";
  const firstInitial = fullName[0] || "";

  return (
    <div className="cw-flex cw-w-full cw-h-[72px] cw-items-center cw-font-brand cw-bg-white cw-px-3 sm:cw-px-7 cw-py-1 sm:cw-py-3 cw-box-border cw-border-0 cw-border-b cw-border-solid cw-border-gray-200 cw-gap-4">
      <div className="cw-flex cw-gap-4 cw-items-center">
        <LogoClock
          fill="currentColor"
          className="cw-text-dusk-standard cw-flex sm:cw-hidden cw-max-w-[32px]"
        />
        <LogoHorizontal
          fill="currentColor"
          className="cw-text-dusk-standard cw-max-w-[180px] cw-hidden sm:cw-flex"
        />
        <div className="cw-text-xl sm:cw-text-2xl cw-font-bold cw-text-slate-standard">
          {pageTitle}
        </div>
      </div>
      <div className="cw-flex-1" />
      {feedbackUrl && (
        <Hidden mdDown>
          <ExternalLinkButton url={feedbackUrl}>Give Feedback</ExternalLinkButton>
        </Hidden>
      )}
      {showCalendarButton && (
        <Hidden mdDown>
          <ExternalLinkButton url={gcalUrl} color="primary" variant="contained">
            Go to Calendar
          </ExternalLinkButton>
        </Hidden>
      )}

      <div className="cw-cursor-pointer" ref={anchorEl} cw-id="top-nav-avatar">
        <Avatar alt={fullName} src={user?.externalImageUrl ?? undefined} onClick={onClick}>
          {firstInitial}
        </Avatar>
      </div>
      <Menu
        id="nav-menu"
        PaperProps={{
          className: "cw-mt-[60px]",
        }}
        keepMounted
        open={open}
        anchorEl={anchorEl.current}
        onClose={onClose}
        disableScrollLock
      >
        <MenuItem onClick={onLogoutAndClose} className="cw-flex cw-gap-1">
          <ExitToApp className="cw-text-slate-standard" />
          <span>Sign out</span>
        </MenuItem>
      </Menu>
    </div>
  );
}
